module.exports = __webpack_public_path__ + "main.bundle.css";